import HomePage from '../pages/home';
import AboutUs from '../pages/aboutus';

export const routes = [
	{
		path: '/',
		label: 'Home',
		exact: true,
		component: HomePage,
		meta: {
			title: 'Rental Hiace Bandung - Sewa Hiace Murah & Cepat | Ketaren Transport',
			description:
				'Ketaren Transport menyediakan rental Hiace terbaik di Bandung dan Indonesia dengan harga terjangkau serta transaksi online yang cepat dan aman.'
		}
	},
	{
		path: '/aboutus',
		label: 'About Us',
		component: AboutUs,
		meta: {
			title: 'Tentang Kami - Ketaren Transport',
			description:
				'Ketahui lebih banyak tentang Ketaren Transport, penyedia rental Hiace terpercaya di Bandung dan seluruh Indonesia.'
		}
	}
];
